import { useQuery } from "@tanstack/react-query";
import { type BaseModalProps, BaseModal, ModalCloseCross } from "@/components/modals/BaseModal";
import { TableImputaciones } from "./TablaImputaciones";
import { getImputacionesFase, type Consumo, type ImputacionFase } from "@/ts/api/API";
import { Constantes } from "@/ts/constantes";
import { useState } from "react";

interface VerImputacionesFaseProps extends BaseModalProps {
	readonly idOF: number | null;
	readonly idFase: number | null;
	readonly descConjunto: string;
}
export function ModalVerImputacionesFase(props: VerImputacionesFaseProps) {
	const [focusedImputacion, setFocusedImputacion] = useState<ImputacionFase | null>(null);

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h2 className="modal-title">
					Imputaciones de la Fase

				</h2>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body" style={{ minWidth: "33vw" }}>
				<h3 style={{ margin: "0" }}>
					<span>OF #{props.idOF}</span>
					{Constantes.existenFases == true && (
						<span>- Fase {props.idFase}</span>
					)}
				</h3>
				<h4 style={{ margin: "1em 0 " }}>
					{props.descConjunto}
				</h4>

				<TableImputaciones
					idOF={props.idOF}
					idFase={props.idFase}
					focusedImputacion={focusedImputacion}
					setFocusedImputacion={setFocusedImputacion}
				/>

				{focusedImputacion ? (
					<div style={{ marginTop: "20px" }}>
						<h4>Consumos de la Imputación Seleccionada</h4>
						<TableDefectuososDesperdiciados
							imputacion={focusedImputacion}
						/>
					</div>
				) : null}
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>
					Cerrar
				</button>
			</div>
		</BaseModal>
	);
}

function TableDefectuososDesperdiciados(props: { readonly imputacion: ImputacionFase; }) {
	const imputacion = props.imputacion;

	return (
		<div className="sub-table-defectuosos mt-3">
			<table className="table table-bordered">
				<thead>
					<tr>
						<th>Artículo</th>
						<th>Desperdiciados</th>
						<th>Defectuosos</th>
					</tr>
				</thead>

				<tbody>
					{imputacion.consumos.map((consumo: Consumo) => {
						return (
							<tr key={`${consumo.idArticulo}_F${consumo.faseArticulo}`}>
								<td>{consumo.descripcion}</td>
								<td>{consumo.cantidadDesperdiciada}</td>
								<td>{consumo.cantidadDefectuosa}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}


export function useImputaciones(idOF: number | null, idFase: number | null) {
	return useQuery<ImputacionFase[]>({
		queryKey: ["imputacionesFase", idOF, idFase],
		queryFn: () => {
			if (idOF == null || idFase == null) return Promise.resolve([]); // Esto no debería pasar por el enabled, pero por si acaso
			return getImputacionesFase(idOF, idFase);
		},
		enabled: idOF != null && idFase != null,
	});
}